export const EXTRA_PAYMENTS_CURRENCY_CODES = {
  BYR: 'BYR',
  USD: 'USD',
};
